import React, { useEffect } from 'react'
import { useOutletContext, useLocation, useNavigate } from 'react-router-dom'
import RoutedMenu from '../../../../RoutedMenu/RoutedMenu'

function Development() {
  const {
    affiliate,
    verificationListing,
    partner,
    listing,
    canUpdate,
    canUpdateBillingRules,
    subTab,
  } = useOutletContext()

  const navigate = useNavigate()
  const location = useLocation()

  const items = []

  const hasNetSuite = partner?.source === 'shopify'

  if (hasNetSuite) {
    items.push({
      label: 'NetSuite',
      to: 'netsuite',
    })
    items.push({
      label: 'Shopify',
      to: 'shopify',
    })
    items.push({
      label: 'Billing',
      to: 'billing',
    })
  }

  // Specs always visible
  items.push({
    label: 'Specs',
    to: 'specs',
  })

  // On initial load of /development (no child path), redirect to the right default:
  // - /development/netsuite when hasNetSuite is true
  // - /development/specs otherwise
  useEffect(() => {
    const path = location.pathname
    const isAtDevelopmentRoot = /\/development\/?$/.test(path)
    if (!isAtDevelopmentRoot) return

    if (partner === undefined) return

    if (hasNetSuite) {
      navigate('netsuite', { replace: true })
    } else {
      navigate('specs', { replace: true })
    }
  }, [location.pathname, partner, hasNetSuite, navigate])

  return (
    <div style={{ margin: '30px 0 0 0' }}>
      <RoutedMenu
        items={items}
        activeTab={subTab}
        context={{
          affiliate,
          verificationListing,
          partner,
          listing,
          canUpdate,
          canUpdateBillingRules,
        }}
      />
    </div>
  )
}

export default Development
